import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function MustMatch(controlName: string, matchingControlName: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const formGroup = group as FormGroup;
    const control = formGroup.get(controlName);
    const matchingControl = formGroup.get(matchingControlName);

    if (!control || !matchingControl) {
      return null;
    }

    // If another validator already set errors (not mustMatch), don't overwrite them.
    if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
      return null;
    }

    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      // Only clear mustMatch (optional: safest approach)
      matchingControl.setErrors(null);
    }

    return null; // group-level validator returns null; it sets errors on the matching control
  };
}
